<prism-dialog [visible]="true" modal="true" *transloco="let t">
	<span slot="dialog-title">{{ title }}</span>

	<div id="sh-dialog-radio-group-button">
		<prism-radio-group
			id="sh-dialog-search-selector"
			[value]="selectedField()"
			(valueChange)="onFieldSelection($event.detail)"
		>
			@for (option of dialogData.fields; track option.name) {
				<prism-radio-button [value]="option.name">
					{{ option.label }}
				</prism-radio-button>
			}
		</prism-radio-group>
	</div>

	<form [formGroup]="searchForm" id="sh-search-dialog-content-container">
		@if (selectedField()) {
			<prism-input
				id="sh-search-dialog-input-field"
				[formControlName]="selectedField()"
				[isValid]="!searchForm.get(selectedField())?.invalid"
				type="text"
				[angularInput]="true"
				required="true"
				(valueInput)="onInputChange($event.detail)"
			>
				<span slot="label">{{ selectFieldLabel() }}</span>
			</prism-input>

			@if (searchForm.get(selectedField())?.invalid && searchForm.get(selectedField())?.touched) {
				<div id="sh-search-dialog-invalid-feedback">
					<span class="prism-caption" id="sh-search-dialog-error-text">
						{{ validationHintMessage() }}
					</span>
				</div>
			}
		}
	</form>

	<div slot="dialog-footer-buttons" id="sh-search-dialog-button">
		<prism-button id="sh-search-dialog-close-button" (click)="handleClose()" variant="bright">
			{{ t('common.buttons.close') }}
		</prism-button>
		<prism-button
			id="sh-search-dialog-ok-button"
			variant="bright"
			(click)="handleClose('submit')"
			[disabled]="!isSubmitEnabled"
		>
			{{ t('common.buttons.ok') }}
		</prism-button>
	</div>
</prism-dialog>
